export const SOURCE_TYPE_ICONS = {
  1: "dashboard", // 画板
  2: "ic_account", // 用户
  3: "link", // 来源
  4: "ic_tag", // 专题（暂无）
  5: "ic_field", // 领域（暂无）
};

export const SOURCE_TYPE_NAMES = {
  1: "画板", // 画板
  2: "用户", // 用户
  3: "来源", // 来源
  4: "专题", // 专题（暂无）
  5: "领域", // 领域（暂无）
};
